if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        // BEGIN FIX: Constrain image zoom horizontally on mobile - XN 01.27.2026
        if (window.innerWidth > 749) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        } else {
          // Force image to fit container on mobile
          activeMedia.style.maxWidth = '100%';
          activeMedia.style.width = 'auto';
          activeMedia.style.height = 'auto';
          activeMedia.style.objectFit = 'contain';
        }
        // Original code (causes horizontal crop on mobile):
        // container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        // END FIX: Constrain image zoom horizontally on mobile - XN 01.27.2026

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
